export enum SettingMessages {
  settingTitlePage = "setting.title.page",
  settingEnvironmentTitle = "setting.environment.title",
  settingDeleteOptionTitle = "setting.optionDelete.title",
  settingChangePasswordOptionTitle = "setting.changePassword.title",
  settingLoginVerificationFailed = "setting.loginVerificationFailed",

  settingNotificationReload = "setting.notification.reload",

  settingParamsTitle = "setting.params.title",
  settingColorsTitle = "setting.colors.title",
  settingIconsTitle = "setting.icons.title",

  settingParamsMinDaysDescription = "setting.params.minDaysDescription",
  settingParamsDaysLabel = "setting.params.daysLabel",
  settingColorsPrimary = "setting.colors.primary",
  settingColorsSecondary = "setting.colors.secondary",
  settingColorsTertiary = "setting.colors.tertiary",
  settingsColorsDisable = "setting.colors.disable",
  settingsColorsLoginBackground = "setting.colors.loginBackground",

  settingParamsSuccessUpdate = "setting.params.successUpdate",
  settingParamsNoChange = "setting.params.noChange",
  settingColorsNoChange = "setting.colors.noChange",
  settingIconsNoChange = "setting.icons.noChange"
}

export interface TranslationSettingMessages {
  [SettingMessages.settingTitlePage]: string;
  [SettingMessages.settingDeleteOptionTitle]: string;
  [SettingMessages.settingChangePasswordOptionTitle]: string;
  [SettingMessages.settingLoginVerificationFailed]: string;
  [SettingMessages.settingParamsTitle]: string;
  [SettingMessages.settingColorsTitle]: string;
  [SettingMessages.settingIconsTitle]: string;
  [SettingMessages.settingParamsMinDaysDescription]: string;
  [SettingMessages.settingParamsDaysLabel]: string;
  [SettingMessages.settingColorsPrimary]: string;
  [SettingMessages.settingColorsSecondary]: string;
  [SettingMessages.settingColorsTertiary]: string;
  [SettingMessages.settingsColorsDisable]: string;
  [SettingMessages.settingsColorsLoginBackground]: string;
  [SettingMessages.settingEnvironmentTitle]: string;
  [SettingMessages.settingParamsSuccessUpdate]: string;
  [SettingMessages.settingParamsNoChange]: string;
  [SettingMessages.settingNotificationReload]: string;
  [SettingMessages.settingColorsNoChange]: string;
  [SettingMessages.settingIconsNoChange]: string;
}
